export default __webpack_public_path__ + "static/media/Accreditation-4.fae721a0.png";